import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";
import { STEPS } from "./data";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.8", "end 0.6"] });
  const scale = useSpring(scrollYProgress, { stiffness: 80, damping: 20 });

  return (
    <section id="process" className="bg-white py-24 sm:py-32" data-testid="process-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Eyebrow>How a trade works</Eyebrow>
        <Reveal>
          <h2 className="mt-6 max-w-4xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-navy sm:text-6xl">
            Clear steps. <em className="font-serif font-normal italic text-copper">No surprises.</em>
          </h2>
        </Reveal>
        <div ref={ref} className="relative mt-20">
          <div className="absolute left-[11px] top-0 h-full w-px bg-navy/12 lg:left-0 lg:top-[11px] lg:h-px lg:w-full" />
          <motion.div style={{ scaleX: scale }} className="absolute left-0 top-[11px] hidden h-px w-full origin-left bg-copper lg:block" />
          <motion.div style={{ scaleY: scale }} className="absolute left-[11px] top-0 h-full w-px origin-top bg-copper lg:hidden" />
          <ol className="grid gap-12 lg:grid-cols-5 lg:gap-8">
            {STEPS.map((s, i) => (
              <Reveal as="li" key={s.title} delay={i * 0.1} className="relative pl-12 lg:pl-0 lg:pt-14">
                <span className="absolute left-0 top-0 grid h-6 w-6 place-items-center rounded-full border border-copper bg-white">
                  <span className="h-2 w-2 rounded-full bg-copper" />
                </span>
                <p className="font-serif text-5xl italic text-navy/25">0{i + 1}</p>
                <h3 className="mt-4 font-display text-xl font-bold text-navy" data-testid={`process-step-${i}`}>{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.text}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
